import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { environment as env } from '@environments/environment';
import { ApiService } from '@shared/services/api.service';
import { AuthService } from '@shared/services/auth.service';
import { LocaleService } from '@shared/services/locale.service';
import { ViewportService } from '@shared/services/viewport.service';
import { VideoModalComponent } from '@shared/components/video-modal/video-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { AdsApi } from '@core/apis/ads.api';

@Component({
	selector: 'app-payment-tier',
	templateUrl: './payment-tier.component.html',
	styleUrls: ['./payment-tier.component.scss'],
})
export class PaymentTierComponent implements OnInit {
	constructor(
		public locale: LocaleService,
		public viewport: ViewportService,
		private route: ActivatedRoute,
		private title: Title,
		private auth: AuthService,
		private api: ApiService,
		private readonly deviceDetectorService: DeviceDetectorService,
		private router: Router,
		private dialog: MatDialog,
		private location: Location,
		private adsApi: AdsApi
	) {}

	adID: string;
	from: string;
	user: Object = this.auth?.user();
	loading = false;
	ad: any = [];
	hideButton = false;

	onOpenBoostAdDialog(planSelected: string) {
		this.router.navigate(['/payment'], {
			queryParams: {
				package: planSelected,
				adID: this.adID,
				Cat: this.ad['data']['catID'],
				lang: this.locale.lang,
			},
		});
	}

	getAdDetails() {
		const adFormData: FormData = new FormData();

		// send user ID if logged in
		if (this.user) {
			adFormData.append('userID', this.user['userID']);
		}
		adFormData.append('adID', this.adID);
		adFormData.append('lang', this.locale.lang);
		this.loading = true;
		this.api.ad(adFormData).subscribe((res) => {
			if (res['status'] === '1') {
				this.ad = res['response'];

				if (this.ad['data']?.['paymentStatus'] === '0' || this.ad['data']?.['sold'] === '1' || this.ad['data']?.['catID'] === '') {
					this.hideButton = true;
				}
			} else {
				this.hideButton = true;
			}
			this.loading = false;
		});
	}

	sendWhatsappMessage() {
		const targetDisplay = this.deviceDetectorService.isMobile() ? '_self' : '_blank';
		let templateMessage = encodeURIComponent(this.locale.translations['n732']) + '%0a' + encodeURIComponent(this.ad['data']['adLink']);

		window.open(`${env.WHATSAPP.callForDetails}${+964}${7512347071}&text=${templateMessage}`, targetDisplay);
	}

	onOpenWhatsapp() {
		const targetDisplay = this.deviceDetectorService.isMobile() ? '_self' : '_blank';

		window.open(env.WHATSAPP.callForHelpUrl, targetDisplay);
	}

	onCallCustomerCare() {
		window.location.href = 'tel:' + `07512347071`;
	}

	onBack() {
		this.location.back();
	}

	openVideoModal() {
		this.dialog.open(VideoModalComponent, {
			disableClose: true,
			id: 'videoDialog',
			width: '92vw',
			maxWidth: '100vw',
		});
	}

	ngOnInit(): void {
		this.adsApi.upgradeAd.next(false);
		
		this.route.queryParams.subscribe((queries: Params) => {
			if (queries['adID'] || queries['id']) {
				this.adID = queries['adID'] || queries['id'];
			}
			if (queries['from']) {
				this.from = queries['from'];
			}
		});

		this.getAdDetails();

		if (this.viewport.type === 'mobile' || this.viewport.type === 'tablet') {
			this.openVideoModal();
		}

		this.title.setTitle(this.locale.translations['payment']['n209'] + ' | ' + this.locale.translations['header']['n0']);
	}
}
